export default __webpack_public_path__ + "static/media/chart both.54b3666c.png";